import { createSelector } from 'reselect';
import CarditNestingCarrierPercentageColumns
  from '../../containers/CarditNestingCarrierPercentageColumns';
import CarditNestingCarrierNumberColumns
  from '../../containers/CarditNestingCarrierNumberColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.CARDIT_NESTING_CARRIER.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_CARRIER.isLoading;

export const getData =
  ReportDefinitions.CARDIT_NESTING_CARRIER.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_NESTING_CARRIER.requestParams, CarditNestingCarrierPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_NESTING_CARRIER.requestParams, CarditNestingCarrierNumberColumns);
